import {
    UPDATE_DEALER_CREDENTIALS, UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, UPDATE_DEALER_CREDENTIALS_FAILED, RESET_ALERT,
    BULK_UPDATE_DEALER_CREDENTIALS, BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL, BULK_UPDATE_DEALER_CREDENTIALS_FAILED, PAGE_NUMBER, RESET_PAGE_NUMBER,
} from "./actionTypes"

const initialState = {
    updateError: null,
    updateloading: false,
    updatemessage: null,
    bulkUpdateError: null,
    bulkUpdateloading: false,
    bulkUpdatemessage: null,
    pageNumberChnage: 0,
}

const addDealerCredentials = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_DEALER_CREDENTIALS:
            state = {
                ...state,
                updateloading: true,
                updateError: null,
                updatemessage: null,
            }
            break;

        case UPDATE_DEALER_CREDENTIALS_SUCCESSFUL:
            state = {
                ...state,
                updateloading: false,
                updatemessage: action.payload.message,
                updateError: null,
            }
            break;

        case UPDATE_DEALER_CREDENTIALS_FAILED:
            state = {
                ...state,
                updateloading: false,
                updateError: action.payload,
                updatemessage: null
            }
            break;
        case RESET_ALERT:
            state = {
                ...state,
                updateloading: false,
                updateError: null,
                updatemessage: null,
                bulkUpdateError: null,
                bulkUpdateloading: false,
                bulkUpdatemessage: null
            }
            break;
        case BULK_UPDATE_DEALER_CREDENTIALS:
            state = {
                ...state,
                bulkUpdateloading: true,
                bulkUpdateError: null,
                bulkUpdatemessage: null,
            }
            break;

        case BULK_UPDATE_DEALER_CREDENTIALS_SUCCESSFUL:
            state = {
                ...state,
                bulkUpdateloading: false,
                bulkUpdatemessage: action.payload.message,
                bulkUpdateError: null,
            }
            break;

        case BULK_UPDATE_DEALER_CREDENTIALS_FAILED:
            state = {
                ...state,
                bulkUpdateloading: false,
                bulkUpdateError: action.payload,
                bulkUpdatemessage: null
            }
            break;
        case PAGE_NUMBER:
            state = {
                ...state,
                pageNumberChnage: action.payload,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default addDealerCredentials;